var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolyBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 600 600",
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289 312L317 352L320 347Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 312L244 359L317 352Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 359L251 404L317 352Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317 352L380 346L320 347Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 347L380 290L289 312Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 415L380 346L317 352Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 319L213 342L244 359Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 359L165 380L251 404Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 312L212 319L244 359Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 346L380 290L320 347Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 312L249 232L212 319Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 464L257 426L218 485Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 404L257 426L317 352Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 194L249 232L289 312Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 439L389 415L317 352Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468 320L390 258L380 290Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468 320L380 290L380 346Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 290L364 224L289 312Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 451L373 439L317 352Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 426L360 451L317 352Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 258L364 224L380 290Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 485L257 426L251 404Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 426L256 464L360 451Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 319L165 380L213 342Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 342L165 380L244 359Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 283L165 380L212 319Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468 320L432 368L514 335Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 415L432 368L380 346Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364 224L313 194L289 312Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 196L149 262L249 232Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 232L149 262L212 319Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 262L140 283L212 319Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 380L218 485L251 404Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 464L261 505L360 451Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432 368L468 320L380 346Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 258L372 180L364 224Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 485L261 505L256 464Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364 224L372 180L313 194Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452 163L372 180L390 258Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 122L269 162L313 194Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 194L269 162L249 232Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 283L115 353L165 380Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 380L145 460L218 485Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269 162L242 162L249 232Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 162L175 196L249 232Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 262L78 273L140 283Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 406L145 460L165 380Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 600L300 600L261 505Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 498L145 471L145 460Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 460L145 471L218 485Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514 335L503 325L468 320Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468 320L502 267L390 258Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 466L432 368L389 415Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 466L389 415L373 439Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 563L459 466L360 451Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 451L459 466L373 439Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 325L502 267L468 320Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511 424L514 335L432 368Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 325L514 335L502 267Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 89L341 122L372 180Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372 180L341 122L313 194Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 42L198 78L242 162Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 335L86 406L115 353Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 353L86 406L165 380Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 273L115 353L140 283Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 153L78 273L149 262Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 466L511 424L432 368Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 267L452 163L390 258Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 273L63 335L115 353Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346 577L360 563L261 505Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261 505L360 563L360 451Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 517L538 426L511 424Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 600L346 577L261 505Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509 516L511 424L459 466Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 162L140 136L175 196Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 196L89 153L149 262Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 112L140 136L198 78Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 255L52 265L50 164Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 273L52 265L63 335Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 543L459 466L360 563Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511 424L558 405L514 335Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 195L503 175L502 267Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452 163L370 89L372 180Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 42L242 162L269 162Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 267L503 175L452 163Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 73L375 65L370 89Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 195L502 267L566 234Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 600L261 505L218 485Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351 600L360 563L346 577Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432 600L465 543L360 563Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 498L160 566L145 471Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 471L160 566L218 485Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 406L83 498L145 460Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 501L83 498L14 444Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 498L86 406L14 444Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 600L351 600L346 577Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 448L558 405L538 426Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538 426L558 405L511 424Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375 65L361 73L370 89Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 89L361 73L341 122Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 78L140 136L242 162Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 164L52 265L78 273Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 153L175 196L140 136Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 328L0 335L63 335Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 335L86 406L63 335Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 498L93 562L160 566Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 45L269 162L341 122Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 133L89 153L140 136Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566 234L502 267L600 254Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 73L370 89L452 163Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 566L210 600L218 485Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 543L509 516L459 466Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 135L452 163L503 175Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 73L305 45L341 122Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 254L502 267L514 335Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509 516L523 517L511 424Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 567L523 517L509 516Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 567L509 516L465 543Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 147L505 135L535 195Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 195L505 135L503 175Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 0L305 45L361 73Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 72L85 133L144 112Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 112L85 133L140 136Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 153L50 164L78 273Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351 600L432 600L360 563Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 600L161 600L160 566Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 566L161 600L210 600Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 328L52 265L37 255Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 328L63 335L52 265Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 208L0 328L37 255Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488 77L437 73L452 163Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 0L257 0L305 45Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 45L245 42L269 162Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 78L178 45L144 112Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 133L50 164L89 153Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 335L14 444L86 406Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 501L93 562L83 498Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 448L600 354L558 405Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 405L600 354L514 335Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 552L93 562L78 501Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501 600L507 567L465 543Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 517L560 518L538 426Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566 234L600 201L535 195Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 354L600 254L514 335Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 42L178 45L198 78Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 133L0 79L50 164Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 335L0 447L14 444Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 444L0 478L78 501Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 567L560 518L523 517Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 135L488 77L452 163Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 0L361 73L375 65Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510 53L488 77L505 135Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 451L600 448L538 426Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 156L0 208L50 164Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 164L0 208L37 255Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 518L600 451L538 426Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 600L103 600L93 562Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 562L103 600L160 566Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 447L0 478L14 444Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 254L600 201L566 234Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432 600L501 600L465 543Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 567L550 600L560 518Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 45L257 0L245 42Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 42L215 0L178 45Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 0L375 65L397 0Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397 0L375 65L399 0Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 0L215 0L245 42Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 28L72 72L144 112Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 28L144 112L178 45Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 79L0 156L50 164Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 0L134 28L178 45Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399 0L375 65L437 73Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 0L399 0L437 73Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 147L510 53L505 135Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488 77L470 0L437 73Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 201L600 152L535 195Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 152L600 147L535 195Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501 600L550 600L507 567Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 518L600 541L600 451Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 600L600 541L560 518Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 478L0 552L78 501Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 0L504 24L510 53Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510 53L504 24L488 77Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504 24L470 0L488 77Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 552L16 600L93 562Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 0L72 72L134 28Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 0L51 35L72 72Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 72L0 79L85 133Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 35L0 79L72 72Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 552L0 600L16 600Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 0L84 0L134 28Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 35L0 55L0 79Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 600L600 600L600 541Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 55L51 35Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 0L52 0L51 35Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 13L584 0L510 53Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504 24L584 0L470 0Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 147L600 13L510 53Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 0L0 0L51 35Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 13L600 0L584 0Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyBg);
export default __webpack_public_path__ + "static/media/polyBG.9e2d28c0e870f31a7812d09dd48eccd0.svg";
export { ForwardRef as ReactComponent };